<template>
  <vc-share-a
    :href="shareIconUrl"
    :target="disabled ? '_self' : '_blank'"
    rel="nofollow"
  >
    <img
      :src="imageSrc[imageType]"
      alt="logo"
      :width="iconSize"
      :height="iconSize"
      :class="[$style.shareIcon, imageClass]"
    />
  </vc-share-a>
</template>

<script>
export default {
  name: "vc-share-twitter-share-icon",
  props: {
    twitterText: {
      type: String,
      default: ""
    },
    twitterHashTags: {
      type: String,
      default: ""
    },
    srcUrl: {
      type: String,
      default: ""
    },
    iconSize: {
      type: String,
      default: "35px"
    },
    imageClass: {
      type: Array,
      default: () => {
        return [];
      }
    },
    imageType: {
      type: String,
      default: "normal"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      imageSrc: {
        normal: require("./assets/ph_sns_x.png"),
        footer: require("./assets/ph_sns_x_b.png")
      }
    };
  },
  computed: {
    shareIconUrl: function() {
      return this.getShareIconUrl();
    }
  },
  methods: {
    getShareIconUrl: function() {
      if (this.disabled) {
        return "javascript:void(0)";
      }

      // シェアメッセージの制御は設定されていればそれを利用し、設定されていなければtitleタグから取得する
      let txt = this.twitterText;
      if (!txt) {
        txt = document.title;
      }

      // URLエンコードされている可能性があるので、デコードする
      let srcurl = decodeURIComponent(this.srcUrl);

      // URLについて、ツイッター画面表示時にデコードされる。
      // URLエンコードされた状態でツイートしないと、URLに全角文字が含まれている場合にURLが途切れてしまう。
      // そのため、下記の2回エンコードを行う
      // 1. ツイートするURLを作成するためのエンコード （: や / はエンコードしない）
      // 2. ツイッターに渡すためのエンコード （すべての文字をエンコード）
      let url =
        "https://twitter.com/share?text=" +
        this.fixedEncodeURIComponent(txt) +
        "&url=" +
        this.fixedEncodeURIComponent(this.encodeURIforTwitter(srcurl));

      let hashTags = this.twitterHashTags;
      if (hashTags !== undefined && hashTags !== "") {
        url += "&hashtags=" + this.fixedEncodeURIComponent(hashTags);
      }
      return url;
    },
    // RFC 3986 仕様を忠実に順守するURLエンコード
    // encodeURIComponent() では、カッコがエンコードされないため、ツイート時にカッコが抜けてしまうことがある
    fixedEncodeURIComponent: function(str) {
      return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16);
      });
    },
    encodeURIforTwitter: function(str) {
      return encodeURI(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16);
      });
    }
  }
};
</script>

<style module>
.shareIcon:hover {
  opacity: 0.5;
}
</style>
